document.addEventListener('DOMContentLoaded', function () {
  const announcementsSlider = document.querySelector('#announcements-slider')

  if (!announcementsSlider) {
    return
  }

  new Splide('#announcements-slider', {
    type: 'loop',
    perPage: 1,
    pagination: false,
    arrows: false,
    autoplay: true,
    interval: parseInt(announcementsSlider.dataset.sliderSpeed)
  }).mount()
})
